// src/components/UserDropdown.js
import React, { useContext } from "react";
import { createPopper } from "@popperjs/core";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../AuthContext"; // Import the AuthContext
import { useDispatch } from "react-redux";
import { deleteCookie } from "cookies-next";

const UserDropdown = () => {
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-start",
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };

  const handleLogout = () => {

    deleteCookie("token");
    deleteCookie("user");

    navigate("/");
  };
  return (
    <>
      <a
        className="text-blueGray-500 block"
        href="#pablo"
        ref={btnDropdownRef}
        onClick={(e) => {
          e.preventDefault();
          dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
        }}
      >
        {/* Add user profile image or icon here */}
      </a>
      <button
        className={
          "btn_logout"
        }
        onClick={handleLogout}
      >
        Logout
      </button>
    </>
  );
};

export default UserDropdown;

